/**
 * Surveys tab (assignment list) for included / excluded / withdrawn.
 * List uses READ_FORM; View/Edit/Cancel/Print are gated separately (edit/send + included).
 */
export const SURVEY_TAB_ELIGIBILITY = [
  "included",
  "excluded",
  "withdrawn",
] as const;

/** Hide Surveys for unverified / decide_later (and empty). */
export function canShowSurveysTab(
  eligibilityStatus?: string | null
): boolean {
  if (!eligibilityStatus) return false;
  return (SURVEY_TAB_ELIGIBILITY as readonly string[]).includes(
    eligibilityStatus
  );
}

/** Assign / re-send only for included participants. */
export function canAssignSurvey(
  eligibilityStatus?: string | null
): boolean {
  return eligibilityStatus === "included";
}

/** Staff view/edit survey answers — included only (matches EDIT_SURVEY_RESPONSE RBAC). */
export function canEditSurveyResponses(
  eligibilityStatus?: string | null
): boolean {
  return eligibilityStatus === "included";
}
